import React from 'react';
import dateformat from 'dateformat';
import { SeparationType } from '../../enums/SeparationType';
import { useAuth } from '../../contexts/AuthContext';
import ServicesContext from '../../contexts/ServicesContext';
import { OrderForListing } from '../../models/OrderForListing';
import { StatePrescriptionLog } from '../../models/StatePrescriptionLog';
import { StateLog } from '../../models/StateLog';
import { StateOrderPopover } from './StateOrderPopover';

interface IStateOrderCellProps {
  separationType?: SeparationType;
  orderForListing?: OrderForListing;
  currentStatePrescription?: StatePrescriptionLog;
  currentState?: StateLog;
}

export const StateOrderCell: React.FC<IStateOrderCellProps> = ({
  separationType,
  orderForListing,
  currentStatePrescription,
  currentState
}) => {

  const { session } = useAuth();
  const { statesService } = React.useContext(ServicesContext);

  const currentStateName = statesService.translateByUserProfile(
    currentState?.currentStateId,
    orderForListing?.currentStateName,
    session?.user?.profileType
  );
  const currentStateCreatedAt = currentState?.createdAt || orderForListing?.stateLog?.createdAt;

  return <>
    <div>
      {currentStateName}
      <StateOrderPopover orderForListing={orderForListing} currentState={currentState} color='red' alertType='no_nfe' />
    </div>
    {currentStateCreatedAt ? <div style={{fontSize:'0.6em', color:'#969697'}}>{dateformat(currentStateCreatedAt, 'dd/mm/yy HH:MM')}</div> : '' }
  </>;

}